import { Breadcrumbs } from "features/common/components/Breadcrumbs";
import { Watermark } from "features/common/components/Watermark";
import { Box } from "@mui/material";
import env from "config/env";

export const InfoApp = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    }}
  >
    <Breadcrumbs />
    <Box
      sx={{
        height: "24px",
        marginBottom: "10px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Watermark env={env.REACT_APP_ENV} />
    </Box>
  </Box>
);
